import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';

const useAdjustment = (tuitionData) => {
    const formatter = Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const [doingAjax, setDoingAjax] = React.useState(false);
    const [description, setDescription] = React.useState(tuitionData?.AdjustmentDescription || '');
    const [adjustment, setAdjustment] = React.useState(
        !isNaN(parseFloat(tuitionData?.AdjustmentAmount)) ? formatter.format(tuitionData.AdjustmentAmount).replace('$', '') : '0.00'
    );
    const [errors, setErrors] = React.useState([]);

    const sanitizeAdjustment = (adj) => {
        return parseFloat(adj.replace(/[^-.\d]/g, ''));
    };

    const updateDescription = (newDescription) => {
        setErrors((prev) => prev.filter((ent) => ent !== 'description'));
        setDescription(newDescription);
    };

    const updateAdjustment = (newAdjustment, type) => {
        setErrors((prev) => prev.filter((ent) => ent !== 'adjustment'));
        switch (type) {
            case 'blur':
                let sanitizedAdjustment = sanitizeAdjustment(newAdjustment);
                setAdjustment(!isNaN(sanitizedAdjustment) ? formatter?.format(sanitizedAdjustment)?.replace('$', '') : '0.00');
                break;
            default:
                setAdjustment(newAdjustment);
        }
    };

    const saveAdjustment = async () => {
        setDoingAjax(true);
        var toastId = toast.loading('Saving adjustment...');

        let _errors = [];
        if (description === '') {
            _errors.push('description');
        }
        if (sanitizeAdjustment(adjustment) === 0) {
            _errors.push('adjustment');
        }

        if (_errors.length > 0) {
            setErrors(_errors);
            setDoingAjax(false);
            toast.dismiss(toastId);
            return false;
        }

        try {
            await API.post('ShipyardAPI', '/finances/overview/add_adjustment', {
                body: {
                    appInstId: tuitionData?.AppInstID,
                    schoolId: tuitionData?.SchoolID,
                    adjAmount: sanitizeAdjustment(adjustment),
                    adjDesc: description,
                },
            });

            toast.dismiss(toastId);

            toast.success('Adjustment saved successfully.');

            return true;
        } catch (e) {
            toast.dismiss(toastId);
            toast.error('Save API failure.');

            setDoingAjax(false);
            return false;
        }
    };

    const deleteAdjustment = async () => {
        setDoingAjax(true);

        var toastId = toast.loading('Deleting adjustment...');

        try {
            await API.post('ShipyardAPI', '/finances/overview/delete_adjustment', {
                body: {
                    appInstId: tuitionData?.AppInstID,
                    schoolId: tuitionData?.SchoolID,
                },
            });

            toast.dismiss(toastId);

            toast.success('Adjustment deleted successfully.');

            return true;
        } catch (e) {
            setDoingAjax(false);

            toast.dismiss(toastId);

            toast.error('Deletion API failed.');

            return false;
        }
    };

    return {
        doingAjax,
        description,
        adjustment,
        errors,
        updateDescription,
        updateAdjustment,
        saveAdjustment,
        deleteAdjustment,
    };
};

export default useAdjustment;
